<div class="video-popup">
  @if (videoEmbedURL) {
    <iframe width="420" height="315"
      [src]="videoEmbedURL" allow="autoplay">
    </iframe>
  }
</div>
